const routes = {
  register: () => `user/register`,
  login: () => `user/login`,
  changePassword: () => `user/change-password`,
  createApiKey: () => `user/api-key`,
  getApiKeys: () => `user/api-key`,
  sendResetCode: () => `user/forgot-password`,
  verifyCode: () => `user/forgot-password/verify`,
  deleteApiKey: (id) => `user/api-key/${id}`,
  getUserProfile: (id) => `user/profile`,
  updateUserProfile: (id) => `user/profile`,
  // channel
  channels: () => `channels`,
  updateChannel: (id) => `channels/${id}`,
  deleteChannel: (id) => `channels/${id}`,
  // watermark
  createWatermark: (id) => `channels/${id}/watermarks`,
  updateWatermark: (watermarkId) => `watermarks/${watermarkId}`,
  getWatermark: (watermarkId) => `watermarks/${watermarkId}`,
  deleteWatermark: (watermarkId) => `watermarks/${watermarkId}`,
  getWatermarks: (id) => `channels/${id}/watermarks`,
  // ads
  assignAdsVideo: (videoId) => `videos/${videoId}/ads`,
  getAdsVideo: (videoId) => `videos/${videoId}/ads`,
  createAds: () => `ads`,
  updateAds: (adsId) => `ads/${adsId}`,
  getAllAds: () => `ads`,
  getAds: (adsId) => `ads/${adsId}`,
  deleteAds: (adsId) => `ads/${adsId}`,
  // profile
  createProfile: (id) => `channels/${id}/profiles`,
  updateProfile: (profileId) => `profiles/${profileId}`,
  getProfile: (profileId) => `profiles/${profileId}`,
  deleteProfile: (profileId) => `profiles/${profileId}`,
  getProfiles: (id) => `channels/${id}/profiles`,
  // videos
  createVideo: (id) => `channels/${id}/videos`,
  getVideos: (id, skip, take) => `channels/${id}/videos?skip=${skip}&take=${take}`,
  getVideo: (id) => `videos/${id}`,
  deleteVideo: (id) => `videos/${id}`,
  updateVideo: (id) => `videos/${id}`,
  // stream
  createStream: (id) => `channels/${id}/streams`,
  getStreams: (id) => `channels/${id}/streams`,
  getStream: (id) => `stream/${id}`,
  getStreamStatus: (slug) => `stream/info/${slug}`,
  deleteStream: (id) => `stream/${id}`,
  updateStream: (id) => `stream/${id}`,
  // stream record
  getStreamRecords: (id) => `channels/${id}/stream-records`,
  getStreamRecord: (id) => `stream-record/${id}`,
  deleteStreamRecord: (id) => `stream-record/${id}`,
  // audio
  createAudio: (id) => `channels/${id}/audios`,
  getAudios: (id, skip, take) => `channels/${id}/audios?skip=${skip}&take=${take}`,
  getAudio: (id) => `audios/${id}`,
  deleteAudio: (id) => `audios/${id}`,
  updateAudio: (id) => `audios/${id}`,
  // subtitle
  createSubtitle: (id) => `videos/${id}/subtitles`,
  getSubtitles: (id) => `videos/${id}/subtitles`,
  getSubtitle: (id) => `subtitles/${id}`,
  deleteSubtitle: (id) => `subtitles/${id}`,
  // dub
  createDub: (id) => `videos/${id}/audio-tracks`,
  getDubs: (id) => `videos/${id}/audio-tracks`,
  getDub: (id) => `audio-tracks/${id}`,
  deleteDub: (id) => `audio-tracks/${id}`,
  // convert info
  getMovieConvertInfo: () => `convert-info/movie`,
  getAudioConvertInfo: () => `convert-info/audio`,
  // tag
  getVideoTag: (id) => `videos/${id}/tags`,
  putVideoTag: (id) => `videos/${id}/tags`,
  // file
  getFiles: (id, skip, take, type) =>
    `channels/${id}/files?skip=${skip}&take=${take}${type ? `&type=${type}` : ''}`,
  deleteFile: (id) => `files/${id}`,
  addFromUrl: (id) => `channels/${id}/files/download`,
  // movie convert info
  getAdminMovieConvertInfo: () => `admin/convert-info`,
  createAdminMovieConvertInfo: () => `admin/convert-info`,
  updateAdminMovieConvertInfo: (id) => `admin/convert-info/${id}`,
  deleteAdminMovieConvertInfo: (id) => `admin/convert-info/${id}`,
  // audio convert info
  getAdminAudioConvertInfo: () => `admin/convert-info-audio`,
  createAdminAudioConvertInfo: () => `admin/convert-info-audio`,
  updateAdminAudioConvertInfo: (id) => `admin/convert-info-audio/${id}`,
  deleteAdminAudioConvertInfo: (id) => `admin/convert-info-audio/${id}`,
}

export default routes
